module.exports = __webpack_public_path__ + "img/8c321d0.svg";